import React, { useEffect, useRef, useState } from 'react';

const LazyImage = ({ src, alt, style, className, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const imgElement = imgRef.current;

    const loadImage = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (imgElement) {
            imgElement.src = imgElement.getAttribute('data-src');
            observer.unobserve(imgElement);
          }
        }
      });
    };

    const observer = new IntersectionObserver(loadImage, {
      threshold: 0.1,
    });

    if (imgElement) {
      observer.observe(imgElement);
    }

    return () => {
      if (imgElement) {
        observer.unobserve(imgElement);
      }
    };
  }, []);

  return (
    <img
      ref={imgRef}
      loading="lazy"
      decoding="async"
      data-src={src}
      alt={alt}
      src=""
      onError={(e) => {
        const currentSrc = e.currentTarget.src;

        // Only replace once if still pointing to idukki-cdn.com
        if (currentSrc.includes('idukki-cdn.com')) {
          e.currentTarget.onerror = null;
          e.currentTarget.src = src?.replace('https://idukki-cdn.com', 'https://assets.idukki.io');
        }
      }}
      onLoad={() => setIsLoaded(true)}
      className={`${className} ${isLoaded ? 'loaded' : 'loading'}`}
      style={{
        ...style,
        opacity: isLoaded ? 1 : 0,
        transition: 'opacity 0.5s ease-in-out',
      }}
      {...props}
    />
  );
};

export default LazyImage;
